import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";

export class ClassesSets extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      bookList: [],
      classCreate: false,
      classSelected: false,
      selectedClass: "",
      selectedClassDate: "",
      selectedClassDisplayDate: "",
      selectedClassTime: "",
      selectedClassInstructors: [],
      selectedClassClientDetails: [],
      selectedClassClients: [],
      selectedClassId: "",
      selectedClassSetId: "",
      selectedClassLastUpdatedDateTime: "",
      selectedClassCurrencyCode: "",
      selectedClassBookedBookList: [],
      selectedClassRoomId: "",
      classEdited: false,
      editedClass: "",
      editedClassDate: "",
      editedClassTime: "",
      editedClassInstructors: "",
      editedClassClients: "",
      editedClassRoomId: "",
      instructorList: [],
      pickListAvailable: [],
      pickListSelected: [],
      roomList: [],
      roomOptions: [],
      deleteDialog: false
    };
  }

  componentDidMount = () => {
    this.getRooms();
    this.getInstructors();
    this.getClasses();
  };

  swapCreate = async userId => {
    this.setState({ loaded: false });

    let swapRequest = new Belfastpilatesappspotcom.SwapRequest();
    swapRequest.codeTag = localStorage.getItem("globalBid");
    swapRequest.userId = localStorage.getItem("userId");
    swapRequest.setId = this.state.selectedClassSetId;
    swapRequest.origBookId = this.state.selectedClassId;
    if (Array.isArray(this.state.selectedClassBookedBookList)) {
      this.state.selectedClassBookedBookList.forEach(e => {
        if (e.userId === userId) {
          swapRequest.swappedBookId = e.id;
        }
      });
    }

    await api("swapApiV1SwapCreate", swapRequest).then(res => {
      if (res.data) {
        let swapResponse = Belfastpilatesappspotcom.SwapResponse.constructFromObject(
          res.data
        );
        console.log(swapResponse);

        if (swapResponse.errorCode === 0) {
          this.setState({ classSelected: false, classEdited: false }, () => {
            this.getClasses();
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Swap could not be created, please try again",
            life: 3000
          });
        }
      } else {
        console.log("swapApiV1SwapCreate has failed");
      }
    });
  };

  getRooms = async () => {
    let roomRequest = new Belfastpilatesappspotcom.RoomRequest();
    roomRequest.codeTag = localStorage.getItem("globalBid");

    await api("roomApiV1RoomGetByCodeTag", roomRequest).then(res => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let roomResponse = Belfastpilatesappspotcom.RoomResponse.constructFromObject(
          res.data
        );
        console.log(roomResponse);

        if (roomResponse.errorCode === 0) {
          this.setState(
            {
              roomList: roomResponse.roomList
            },
            () => {
              this.roomsToOptions();
            }
          );
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Rooms could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("roomApiV1RoomGetByCodeTag has failed");
      }
    });
  };

  roomsToOptions = () => {
    let roomArray = [];

    if (Array.isArray(this.state.roomList)) {
      this.state.roomList.forEach(e => {
        roomArray.push({ label: e.name, value: e.id });
      });
    }

    this.setState({ roomOptions: roomArray });
  };

  async getInstructors() {
    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");

    await api("userApiV1UserListInBusiness", userRequest).then(res => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let userResponse = Belfastpilatesappspotcom.UserResponse.constructFromObject(
          res.data
        );
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            instructorList: userResponse.users,
            pickListAvailable: userResponse.users
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Instructors could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("userApiV1UserListInBusiness has failed");
      }
    });
  }

  async getClasses() {
    this.setState({ loaded: false });

    let setRequest = new Belfastpilatesappspotcom.SetRequest();
    setRequest.codeTag = localStorage.getItem("globalBid");
    setRequest.id = localStorage.getItem("selectedSetId");
    setRequest.bookIdentifier = "CREATE";

    await api("setApiV1SetGetById", setRequest).then(res => {
      if (res.data) {
        if (Array.isArray(res.data.bookList)) {
          res.data.bookList.forEach(e => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
            if (Array.isArray(e.date)) {
              e.date = e.date.toJSON();
            }
          });
        }

        let setResponse = Belfastpilatesappspotcom.SetResponse.constructFromObject(
          res.data
        );
        console.log(setResponse);

        if (setResponse.errorCode === 0) {
          this.setState({
            bookList: setResponse.bookList
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Classes could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("setApiV1SetGetById has failed");
      }
    });

    this.setState({ loaded: true });
  }

  updateClass = async ids => {
    let idArray = [];

    let bookRequest = new Belfastpilatesappspotcom.BookRequest();
    bookRequest.codeTag = localStorage.getItem("globalBid");
    bookRequest.id = this.state.selectedClassId;
    bookRequest.lastUpdatedDateTime = this.state.selectedClassLastUpdatedDateTime;
    bookRequest.currencyCode = this.state.selectedClassCurrencyCode;
    bookRequest.roomId = this.state.editedClassRoomId;
    if (ids) {
      bookRequest.instructorIds = ids;
    }
    if (Array.isArray(this.state.pickListSelected)) {
      this.state.pickListSelected.forEach(e => {
        idArray.push(e.id);
      });
      bookRequest.instructorIds = idArray;
    }

    await api("bookApiV1BookUpdate", bookRequest).then(res => {
      if (res.data) {
        let bookResponse = Belfastpilatesappspotcom.BookResponse.constructFromObject(
          res.data
        );
        console.log(bookResponse);

        if (bookResponse.errorCode === 0) {
          this.setState({ classSelected: false, classEdited: false }, () => {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Class successfully updated",
              life: 3000
            });
            this.getClasses();
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Classe could not be updated, please try again",
            life: 3000
          });
        }
      } else {
        console.log("bookApiV1BookUpdate has failed");
      }
    });
  };

  deleteClass = async () => {
    let bookRequest = new Belfastpilatesappspotcom.BookRequest();
    bookRequest.codeTag = localStorage.getItem("globalBid");
    bookRequest.userId = localStorage.getItem("userId");
    bookRequest.id = this.state.selectedClassId;
    bookRequest.lastUpdatedDateTime = this.state.selectedClassLastUpdatedDateTime;

    await api("bookApiV1BookDelete", bookRequest).then(res => {
      if (res.data) {
        let bookResponse = Belfastpilatesappspotcom.BookResponse.constructFromObject(
          res.data
        );
        console.log(bookResponse);

        if (bookResponse.errorCode === 0) {
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Class successfully deleted",
            life: 3000
          });
          this.getClasses();
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Class could not be deleted, please try again",
            life: 3000
          });
        }
      } else {
        console.log("bookApiV1BookDelete has failed");
      }
    });
  };

  booksToCard = () => {
    let bookArray = [];
    let i = 0;
    let instructorNamesArray = [];
    let i2 = 0;
    let clientNamesArray = [];
    let i3 = 0;

    if (!Array.isArray(this.state.bookList)) {
      return;
    }
    this.state.bookList.forEach(e => {
      bookArray[i] = (
        <div
          key={i}
          id={i}
          className="card"
          onMouseOver={f => {
            f.currentTarget.style.boxShadow = "5px 5px 10px grey";
          }}
          onMouseOut={f => {
            f.currentTarget.style.boxShadow = "";
          }}
          onClick={g => {
            let element = document.getElementById(
              localStorage.getItem("classesSetsLastSelectedCardId")
            );
            if (element) {
              element.style.backgroundColor = "white";
            }
            g.currentTarget.style.backgroundColor = "#F44336";
            localStorage.setItem(
              "classesSetsLastSelectedCardId",
              g.currentTarget.id
            );

            if (e.instructorDetails !== undefined) {
              e.instructorDetails.forEach(f => {
                instructorNamesArray[i2] = (
                  <li key={i2}>{f.firstName + " " + f.surname}</li>
                );
                i2++;
              });
            }

            if (e.bookedUserDetails !== undefined) {
              e.bookedUserDetails.forEach(f => {
                clientNamesArray[i3] = (
                  <li key={i3}>{f.firstName + " " + f.surname}</li>
                );
                i3++;
              });
            }

            this.setState(
              {
                classCreate: false,
                classEdited: false,
                classSelected: true,
                selectedClass: e,
                selectedClassDate: e.date,
                selectedClassDisplayDate: e.dateToDisplay,
                selectedClassTime: e.startTime,
                selectedClassInstructorDetails: e.instructorDetails,
                selectedClassInstructors: instructorNamesArray,
                selectedClassClientDetails: e.bookedUserDetails,
                selectedClassClients: clientNamesArray,
                selectedClassId: e.id,
                selectedClassSetId: e.setId,
                selectedClassLastUpdatedDateTime: e.lastUpdatedDateTime,
                selectedClassCurrencyCode: e.currencyCode,
                selectedClassBookedBookList: e.bookedBookList,
                pickListSelected: e.instructorDetails,
                selectedClassRoomId: e.roomId
              },
              () => {
                console.log(this.state.selectedClass);
                window.scrollTo({ top: 0, behavior: "smooth" });
                if (Array.isArray(this.state.pickListSelected)) {
                  this.removePickListDuplicates();
                }
              }
            );
          }}
          style={{
            cursor: "pointer"
          }}
        >
          <div className="ui-g" style={{ textAlign: "center" }}>
            <div className="ui-g-12 ui-md-4" style={{ textAlign: "left" }}>
              <br />
              <h1>{e.dateToDisplay || ""}</h1>
            </div>
            <div className="ui-g-12 ui-md-4">
              <h1>{e.startTime || "07:00am"}</h1>
              <h1>{e.endTime || "08:00am"}</h1>
            </div>
            <div className="ui-g-12 ui-md-4">
              <pr.DataTable
                value={e.instructorDetails}
                selectionMode="single"
                onSelectionChange={e => {}}
                header="Instructors"
                autoLayout={true}
                paginator={false}
                alwaysShowPaginator={false}
                scrollable={true}
                emptyMessage="No instructors set"
              >
                <pr.Column
                  field="firstName"
                  header="First Name"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="surname"
                  header="Surname"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
              </pr.DataTable>
            </div>
          </div>
        </div>
      );
      i++;
    });

    return bookArray;
  };

  removePickListDuplicates = () => {
    let i = 0;

    this.state.pickListAvailable.forEach(e => {
      this.state.pickListSelected.forEach(f => {
        if (e.id === f.id) {
          let pickListAvailable = this.state.pickListAvailable;
          pickListAvailable.splice(i, 1);
          this.setState({ pickListAvailable: pickListAvailable });
          i--;
        }
      });
      i++;
    });
  };

  roomToDisplay = () => {
    let roomToDisplay = "";

    if (Array.isArray(this.state.roomList)) {
      this.state.roomList.forEach(e => {
        if (e.id === this.state.selectedClassRoomId) {
          roomToDisplay = e.name;
        }
      });
    }

    return roomToDisplay;
  };

  render() {
    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={el => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <div className="ui-g-12">
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={el => (this.growl = el)}
          />
          <pr.Dialog
            header="Delete Class"
            footer={
              <div>
                <pr.Button
                  label="Yes"
                  onClick={() => {
                    this.setState(
                      { deleteDialog: false, setSelected: false },
                      () => {
                        this.deleteClass();
                      }
                    );
                  }}
                  style={{ float: "right" }}
                />
                <pr.Button
                  label="No"
                  onClick={() => {
                    this.setState({ deleteDialog: false });
                  }}
                  style={{ float: "right" }}
                />
              </div>
            }
            visible={this.state.deleteDialog}
            style={{ width: "50vw" }}
            modal={true}
            onHide={e => this.setState({ deleteDialog: false })}
          >
            Are you sure you want to delete?
          </pr.Dialog>

          {!this.state.classSelected ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                <div className="ui-g-12">
                  <pr.Button
                    className="secondary-btn"
                    icon="pi pi-pencil"
                    onClick={() => {
                      this.setState({
                        classSelected: false,
                        classEdited: true,
                        editedClass: this.state.selectedClass,
                        editedClassDate: this.state.selectedClassDate,
                        editedClassTime: this.state.selectedClassTime,
                        editedClassInstructors: this.state
                          .selectedClassInstructors,
                        editedClassClients: this.state.selectedClassClients,
                        editedClassRoomId: this.state.selectedClassRoomId
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <h1>Class Overview</h1>
                </div>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <b>Date: </b>
                    <label>
                      {this.state.selectedClassDisplayDate || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Time: </b>
                    <label>{this.state.selectedClassTime || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Room for Class: </b>
                    <label>{this.roomToDisplay() || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Client(s): </b>
                    <br />
                    <ul>
                      {this.state.selectedClassClients.length === 0 ? (
                        <li>Not Set</li>
                      ) : (
                        this.state.selectedClassClients
                      )}
                    </ul>
                  </div>
                </div>
                <div className="ui-g-6">
                  <div className="ui-g-12">
                    <b>Instructor(s): </b>
                    <br />
                    <ul>
                      {this.state.selectedClassInstructors.length === 0 ? (
                        <li>Not Set</li>
                      ) : (
                        this.state.selectedClassInstructors
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}

          {!this.state.classEdited ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                <div className="ui-g-12">
                  <pr.Button
                    className="secondary-btn"
                    icon="pi pi-times"
                    onClick={() => {
                      this.setState({
                        classEdited: false,
                        classSelected: true
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <h1>Class Overview</h1>
                </div>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <b>Date: </b>
                    <label>
                      {this.state.selectedClassDisplayDate || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Time: </b>
                    <label>{this.state.selectedClassTime || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Room for Class: </b>
                    <br />
                    <pr.Dropdown
                      value={this.state.editedClassRoomId}
                      options={this.state.roomOptions}
                      onChange={e => {
                        this.setState({ editedClassRoomId: e.value });
                      }}
                    />
                  </div>
                  <div className="ui-g-12">
                    <b>Client(s): </b>
                    <br />
                    <br />
                    <pr.DataTable
                      value={this.state.selectedClassClientDetails}
                      selectionMode="single"
                      onSelectionChange={() => {}}
                      header=" "
                      footer=" "
                      autoLayout={true}
                      paginator={false}
                      alwaysShowPaginator={false}
                      scrollable={true}
                    >
                      <pr.Column
                        field="firstName"
                        header="First Name"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="surname"
                        header="Surname"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field=""
                        header=""
                        body={e => {
                          return (
                            <pr.Button
                              label="Add to Swap"
                              onClick={() => {
                                this.swapCreate(e.id);
                              }}
                              style={{ width: "90%" }}
                            />
                          );
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                    </pr.DataTable>
                  </div>
                </div>
                <div className="ui-g-6">
                  <div className="ui-g-12">
                    <b>Instructor(s): </b>
                    <br />
                    <br />
                    <pr.PickList
                      source={this.state.pickListAvailable || []}
                      target={this.state.pickListSelected || []}
                      sourceHeader="Available"
                      targetHeader="Selected"
                      responsive={true}
                      itemTemplate={e => (
                        <span>{e.firstName + " " + e.surname}</span>
                      )}
                      onChange={e => {
                        this.setState({
                          pickListAvailable: e.source,
                          pickListSelected: e.target
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    label="Save"
                    onClick={() => {
                      this.updateClass();
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    label="Delete"
                    onClick={() => {
                      this.setState({ deleteDialog: true });
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    label="Cancel"
                    onClick={() => {
                      this.setState({
                        classEdited: false,
                        classSelected: true
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="ui-g">
            <div className="ui-g-12 ui-md-6">
              <h3>List of Classes in Set</h3>
            </div>
            <div className="ui-g-12 ui-md-6">
              <pr.Button
                label="Add Class to Set"
                onClick={() => {
                  window.location = "#/createclasses";
                }}
                style={{ float: "right" }}
              />
              <pr.Button
                label="Back"
                onClick={() => {
                  window.location = "#/managesets";
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>

          {this.booksToCard()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sets/ClassesSets.js